import React from 'react';
import { FaFacebook, FaTwitter, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-gray-300 py-10">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        
        {/* Contact Info */}
        <div>
          <h3 className="text-lg font-semibold text-green-400 mb-4">Contact Info</h3>
          <p className="mb-2">Active calling hours: 10:00 - 20:00</p>
          <p className="mb-2">📞 +918287373076</p>
          <p className="mb-2">✉️ Info@travelmeventures.com</p>
          <p className="mb-4">📍 Delhi</p>
          <div className="flex space-x-4">
            <a href="#" className="hover:text-green-400"><FaFacebook /></a>
            <a href="#" className="hover:text-green-400"><FaTwitter /></a>
            <a href="#" className="hover:text-green-400"><FaInstagram /></a>
          </div>
        </div>
        
        {/* Important Links */}
        <div>
          <h3 className="text-lg font-semibold text-green-400 mb-4">Important Links</h3>
          <ul>
            <li><a href="#" className="hover:text-green-400">About Us</a></li>
            <li><a href="#" className="hover:text-green-400">Terms and Conditions</a></li>
            <li><a href="#" className="hover:text-green-400">Privacy Policy</a></li>
            <li><a href="#" className="hover:text-green-400">Payment Policy</a></li>
            <li><a href="#" className="hover:text-green-400">Cancellations and Refunds</a></li>
          </ul>
        </div>
        
        {/* Destinations */}
        <div>
          <h3 className="text-lg font-semibold text-green-400 mb-4">Destinations</h3>
          <ul>
            <li><a href="#" className="hover:text-green-400">Vietnam</a></li>
            <li><a href="#" className="hover:text-green-400">Bali</a></li>
            <li><a href="#" className="hover:text-green-400">Dubai</a></li>
            <li><a href="#" className="hover:text-green-400">Thailand</a></li>
          </ul>
        </div>
        
        {/* Trip Types */}
        <div>
          <h3 className="text-lg font-semibold text-green-400 mb-4">Trip Types</h3>
          <ul>
            <li><a href="#" className="hover:text-green-400">Adventure</a></li>
            <li><a href="#" className="hover:text-green-400">Relaxation</a></li>
          </ul>
        </div>
        
      </div>
    </footer>
  );
};

export default Footer;
